import React from 'react';

const Loader = ({ dark }) => (
  <div className={`fixed inset-0 flex items-center z-10 justify-center bg-opacity-50 ${dark ? "bg-gray-800" : "bg-white"}`}>
    <div className="w-16 h-16 relative">
      <div
        className="animate-spin inline-block w-20 h-20 border-[6px] border-green-800 !border-t-transparent text-yellow-1000 rounded-full"
        role="status"
        aria-label="loading"
      ></div>
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

export default Loader;
